module.exports = __webpack_public_path__ + "media/luxury-2026/conyers-entry-7a976ef5.jpg";